/**
 * Coup de pouce, Attendu 1233 « prendre l'opposé d'une expression :
 * −(5 − 4x) = −5 + 4x » (3e, Calcul littéral, l. 800). Seconde passe 3e
 * (2026-09-13). UNE page STATIQUE partagée par les trois clés.
 *
 * L'image que l'élève a déjà : l'opposé d'un nombre (5e, « l'opposé de 5
 * est −5 ») et le signe − devant une parenthèse lu comme « × (−1) » (4e,
 * l. 800 vers 3e). L'exemple du programme : −(5 − 4x). Chaque terme
 * change de signe, l'un après l'autre : 5 devient −5, −4x devient +4x ;
 * résultat −5 + 4x. Vérification qui referme la boucle : l'opposé de
 * l'opposé redonne 5 − 4x ; contre l'erreur principale, un seul terme
 * changé (−5 − 4x).
 *
 * SACRIFIÉ : (5 ; −4) = 5 − 4x, toutes lettres (gen_1233,
 * gen1232-1233.self.test.js).
 */
import { svg } from './1054';

const ORANGE = '#EA580C';
const BLEU = '#2563EB';
const ENCRE = '#1E293B';
const GRIS = '#64748B';

const ligne = (y, contenu, taille = 12, couleur = ENCRE) => `<text x="200" y="${y}" font-size="${taille}" text-anchor="middle" fill="${couleur}">${contenu}</text>`;
const fleche = (x, y1, y2, couleur) => `<line x1="${x}" y1="${y1}" x2="${x}" y2="${y2}" stroke="${couleur}" stroke-width="1.6" marker-end="url(#pte3)"/>`;
const DEFS = `<defs><marker id="pte3" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto"><path d="M 0 0 L 7 3.5 L 0 7 z" fill="${GRIS}"/></marker></defs>`;

const SVG = svg(
    'Moins, parenthèse, 5 moins 4x. Le premier terme 5, en bleu, devient moins 5. Le deuxième terme moins 4x, en orange, devient plus 4x. L’opposé de 5 moins 4x est moins 5 plus 4x. Chaque terme change de signe, pas seulement le premier. Vérification : l’opposé de moins 5 plus 4x redonne 5 moins 4x.',
    `${DEFS}
  <!-- 1. l'expression -->
  <text x="200" y="46" font-size="26" font-weight="bold" text-anchor="middle" fill="${ENCRE}">−(<tspan fill="${BLEU}">5</tspan> <tspan fill="${ORANGE}">− 4x</tspan>)</text>

  <!-- 2. chaque terme change de signe -->
  ${fleche(178, 58, 84, GRIS)}
  ${fleche(240, 58, 84, GRIS)}
  <text x="178" y="106" font-size="22" font-weight="bold" text-anchor="middle" fill="${BLEU}">−5</text>
  <text x="240" y="106" font-size="22" font-weight="bold" text-anchor="middle" fill="${ORANGE}">+ 4x</text>
  <text x="120" y="106" font-size="11" text-anchor="end" fill="${GRIS}">5 devient −5</text>
  <text x="290" y="106" font-size="11" text-anchor="start" fill="${GRIS}">−4x devient +4x</text>

  <!-- 3. le résultat -->
  ${ligne(150, `−(5 − 4x) = <tspan font-weight="bold" fill="${BLEU}">−5</tspan> <tspan font-weight="bold" fill="${ORANGE}">+ 4x</tspan>`, 18)}

  <!-- 4. le geste -->
  ${ligne(186, 'L’opposé change le signe de chaque terme, pas seulement du premier.', 12)}
  ${ligne(208, 'Je vérifie : l’opposé de −5 + 4x redonne 5 − 4x.', 12, GRIS)}`,
    224,
);

const AIDE = { pages: [{ titre: 'L’opposé de chaque terme', svg: SVG }] };

const CP_1233 = {
    oppose_saisie: AIDE,
    oppose_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1233;
